import React, { useRef, useState } from "react";
import { getTranslateByKey } from "@/main/services/utils";
import { Document, Page } from "react-pdf";
import BasicModal from "@/main/components/shared/modal/basicModal";
import * as S from "./styles";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { OnDocumentLoadSuccess } from "react-pdf/dist/cjs/shared/types";
import { AnnouncementDetailResponse } from "@/main/models/response/announcementResponse";

interface ContentModalProps {
	base64: string;
	announcement: AnnouncementDetailResponse;
}

function ContentModal({ base64, announcement }: ContentModalProps) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [totalPages, setTotalPages] = useState(0);

	const handleDocumentLoadSuccess: OnDocumentLoadSuccess = ({ numPages }) => {
		setTotalPages(numPages);
	};

	return (
		<S.Container>
			{base64 !== "" && (
				<>
					<S.PDFContainer ref={containerRef} id="id-eula-ref-pdfviewer">
						<Document
							file={`data:application/pdf;base64,${base64}`}
							onLoadSuccess={handleDocumentLoadSuccess}
							loading={<LoadingComponent />}
							error={<h5>{getTranslateByKey("information.failedLoadFile", true)}</h5>}
						>
							{Array.from(new Array(totalPages), (el, index) => (
								<Page
									key={`page_${index + 1}`}
									pageNumber={index + 1}
									renderTextLayer={false}
									renderAnnotationLayer={false}
									className="pdf-page"
								/>
							))}
						</Document>
					</S.PDFContainer>

					{announcement.displayDontShowMeAgain && (
						<S.FooterContentPreviewModal>
							<span>{getTranslateByKey("information.dontShowMeAgain")}</span>
						</S.FooterContentPreviewModal>
					)}
					{announcement.displayAcceptMessageContent && (
						<S.FooterContentPreviewModal>
							<span>{getTranslateByKey("information.acceptMessageContent")}</span>
						</S.FooterContentPreviewModal>
					)}
				</>
			)}
		</S.Container>
	);
}

interface AnnouncementRegisterPreviewProps {
	open: boolean;
	announcement: AnnouncementDetailResponse;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	base64: string;
}

export function AnnouncementRegisterPreview({ open, announcement, setOpen, base64 }: AnnouncementRegisterPreviewProps) {
	return (
		<BasicModal open={open} handleClose={() => setOpen(false)} boxStyle={{ width: "auto", height: "80dvh" }}>
			<ContentModal base64={base64} announcement={announcement} />
		</BasicModal>
	);
}
